// extracted by mini-css-extract-plugin
export default {"container":"InteractionInstructions_container__26qCG","phrase":"InteractionInstructions_phrase__Dk3Lc"};